import { api } from "assets/scripts/utilities/api-clients";

export const getRecipients = async (options = {}) => {
  //get all recipient of User
  const { params } = options;

  const response = await api.get(
    `/user/${params?.user_id}/recipients`,
    options,
  );

  return response;
};

export const putRecipients = async (recipients = {}) => {
  //update the communication by adding recipient
  const response = await api.put(`/user/communication`, recipients);

  return response;
};

export const putStatus = async (payload = {}) => {
  // rename to putStatus
  const { user_id, status_cd, ...body } = payload;

  const response = await api.put(
    `/user/${user_id}/recipients/status/${status_cd}`,
    body,
  );

  return response;
};

export const put = async (payload = {}) => {
  //update the communication by adding recipient
  const { user_id, recipient_id, ...body } = payload;
  const cleanBody = {
    ...body,
    type: (body.type || []).map((t) => (typeof t === "object" ? t._id : t)),
  };
  const response = await api.put(
    `/user/${user_id}/recipients/${recipient_id}`,
    cleanBody,
  );

  return response;
};

// communicationTypes API's

export const getTypes = async (options = {}) => {
  // get ALl communication types
  const response = await api.get("/data/communication-types", options);

  return response;
};

function transformCommunications(data = []) {
  return data.map((comm) => {
    const { code, name, _id } = comm;

    const recipients = (comm.recipients || []).map((r) => ({
      ...r,
      typeData: {
        code,
        name,
        _id,
      },
    }));

    return {
      ...comm,
      recipients,
    };
  });
}

export const index = async (options = {}) => {
  // get communciation type of a user with recipients and create communication for a User
  const { _id, params } = options;
  const response = await api.get(`/data/communication-types/${_id}`, {
    params,
  });
  const communications = response.data?.data || [];
  const transformed = transformCommunications(communications);

  return transformed;
};
